import axios from 'axios'
import notifService from '../../services/notifService'

export const getCategory = async (context, pagination) => {
  let res = await axios
    .get('/cms/category', {
      params: pagination
    })
    .then(response => {
      context.commit('getCategory', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const listCategory = async (context, pagination) => {
  let res = await axios
    .get('/cms/category', {
      params: pagination
    })
    .then(response => {
      context.commit('categoryList', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const categoryAdd = async (_context, val) => {
  return await axios
    .post('/cms/category/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const categoryEdit = async (_context, val) => {
  return await axios
    .put('/cms/category/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const categoryDelete = async (_context, val) => {
  return await axios
    .delete('/cms/category/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const categoryForm = (context, val) => {
  context.commit('categoryForm', val)
}
